(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[621],{

/***/ 2790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ ArticleCardType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6612);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2991);
/* harmony import */ var _helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7868);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8046);
/* harmony import */ var _lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(204);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2316);
/* harmony import */ var _article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var ArticleCardType;
(function(ArticleCardType) {
    ArticleCardType["Small"] = "small";
    ArticleCardType["Large"] = "large";
})(ArticleCardType || (ArticleCardType = {}));
const ArticleCard = (props)=>{
    var ref, ref1, ref2, ref3;
    const { locale  } = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .useLocale */ .bU)();
    const [isLoading] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const { article , type , fixedWidth  } = props;
    const windowSize = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_5__/* .useWindowSize */ .i)();
    const getClassSkeletonImage = ()=>{
        if (isLoading) {
            return "loading";
        } else {
            return "";
        }
    };
    const targetUrl = (0,_helpers_LangHelper__WEBPACK_IMPORTED_MODULE_4__/* .localifyLink */ .Bj)("/".concat(locale).concat(article.articleUrl), locale);
    const getArticleImage = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(()=>{
        // Horiz image for small card
        let articleImage = article.leadImage || article.leadPortraitImage;
        var _width;
        if (((_width = windowSize.width) !== null && _width !== void 0 ? _width : 0) > 768 && type === ArticleCardType.Large) {
            // Portrait image for Large card
            articleImage = article.leadPortraitImage || article.leadImage;
        }
        return articleImage;
    }, [
        type,
        windowSize.width,
        article
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCard), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[type], {
            [(_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().fixedWidth)]: fixedWidth
        }),
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardImageWrapper), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[getClassSkeletonImage()]),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_lazy_background_image_lazy_background_image__WEBPACK_IMPORTED_MODULE_6__/* .LazyBackgroundImage */ .I, {
                    imageUrl: getArticleImage(),
                    className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardImage)
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardContentWrapper),
                children: [
                    ((ref = article.categories) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().categoriesList),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: (ref2 = article.categories) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardContent),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardContentTitle), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().twoLinesLimit)),
                                children: article.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardContentDescription), (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().twoLinesLimit)),
                                children: [
                                    "".concat(dayjs__WEBPACK_IMPORTED_MODULE_2___default()(article.overrideDate || article.createdDate).format("MMM DD, YYYY")),
                                    article.readingTime && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        children: [
                                            "\xa0\xa0\xa0",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().dot),
                                                children: "•"
                                            }),
                                            "\xa0\xa0\xa0",
                                            "".concat(article.readingTime, " min read")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: targetUrl,
                target: "_self",
                className: (_article_card_module_scss__WEBPACK_IMPORTED_MODULE_7___default().articleCardLink),
                title: article.title
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ArticleCard);


/***/ }),

/***/ 5211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cP": function() { return /* binding */ TEMPLATE_TYPE; },
  "ZP": function() { return /* binding */ article_grid; }
});

// UNUSED EXPORTS: getTemplate

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(8046);
// EXTERNAL MODULE: ./components/article-card/article-card.tsx
var article_card = __webpack_require__(2790);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./components/skeleton-load/image-skeleton/image-skeleton.tsx
var image_skeleton = __webpack_require__(3476);
// EXTERNAL MODULE: ./components/skeleton-load/text-skeleton/text-skeleton.tsx
var text_skeleton = __webpack_require__(8192);
// EXTERNAL MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.module.scss
var article_card_skeleton_module = __webpack_require__(4494);
var article_card_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_card_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/article-card-skeleton/article-card-skeleton.tsx







const ArticleCardSkeleton = (props)=>{
    const { type  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const isMobile = ()=>{
        const windowWidth = windowSize.width || 0;
        if (windowWidth < 768) {
            return true;
        } else {
            return false;
        }
    };
    const renderSmallContent = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                    size: [
                        80,
                        16
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                        size: [
                            "100%",
                            30
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                        size: [
                            "60%",
                            16
                        ]
                    })
                })
            ]
        });
    };
    const renderLargeContent = ()=>{
        if (isMobile()) {
            return renderSmallContent();
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                    size: [
                        80,
                        16
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                        size: [
                            "100%",
                            30
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (article_card_skeleton_module_default()).articleCardSkeletonLeftContentDescription,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_skeleton/* default */.Z, {
                        size: [
                            "60%",
                            16
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_card_skeleton_module_default()).articleCardSkeleton + " " + (article_card_skeleton_module_default())[isMobile() ? "small" : type],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_card_skeleton_module_default()).articleCardSkeletonImage,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_skeleton/* default */.Z, {})
            }),
            type === article_card/* ArticleCardType.Large */._.Large ? renderLargeContent() : renderSmallContent()
        ]
    });
};
/* harmony default export */ var article_card_skeleton = (ArticleCardSkeleton);

// EXTERNAL MODULE: ./components/skeleton-load/article-grid-skeleton/article-grid-skeleton.module.scss
var article_grid_skeleton_module = __webpack_require__(3551);
var article_grid_skeleton_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_skeleton_module);
;// CONCATENATED MODULE: ./components/skeleton-load/article-grid-skeleton/article-grid-skeleton.tsx





const dummyArticleGridSkeleton = [
    {
        type: article_card/* ArticleCardType.Large */._.Large
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Small */._.Small
    },
    {
        type: article_card/* ArticleCardType.Large */._.Large
    }
];
const ArticleGridSkeleton = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (article_grid_skeleton_module_default()).articleGridSkeleton,
        children: dummyArticleGridSkeleton.map((articleSkeleton, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card_skeleton, {
                type: articleSkeleton.type
            }, "article_skeleton_".concat(index));
        })
    });
};
/* harmony default export */ var article_grid_skeleton = (ArticleGridSkeleton);

// EXTERNAL MODULE: ./components/article-grid/article-grid.module.scss
var article_grid_module = __webpack_require__(4688);
var article_grid_module_default = /*#__PURE__*/__webpack_require__.n(article_grid_module);
;// CONCATENATED MODULE: ./components/article-grid/article-grid.tsx






var TEMPLATE_TYPE;
(function(TEMPLATE_TYPE) {
    TEMPLATE_TYPE["DEFAULT"] = "default";
    TEMPLATE_TYPE["THREE_LINE"] = "Three Line";
    TEMPLATE_TYPE["ONE_LINE"] = "One Line";
    TEMPLATE_TYPE["SIX_LINE"] = "Six Line";
})(TEMPLATE_TYPE || (TEMPLATE_TYPE = {}));
const CardType = {
    SMALL: "SMALL",
    LARGE: "LARGE"
};
const templatesDefault = [
    [
        CardType.LARGE,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.LARGE
    ]
];
const templatesThreeLine = [
    [
        CardType.LARGE,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.LARGE
    ]
];
const templatesSixLine = [
    [
        CardType.LARGE,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.LARGE
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.LARGE,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const templatesOneLine = [
    [
        CardType.LARGE,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const tabletTemplate = [
    [
        CardType.LARGE,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ],
    [
        CardType.SMALL,
        CardType.LARGE
    ],
    [
        CardType.SMALL,
        CardType.SMALL,
        CardType.SMALL
    ]
];
const getTemplate = (templateType, windowSize)=>{
    let template;
    switch(templateType){
        case TEMPLATE_TYPE.THREE_LINE:
            template = templatesThreeLine;
            break;
        case TEMPLATE_TYPE.ONE_LINE:
            template = templatesOneLine;
            break;
        case TEMPLATE_TYPE.SIX_LINE:
            template = templatesSixLine;
            break;
        default:
            template = templatesDefault;
            if ((windowSize.width || 0) <= 1200) {
                template = tabletTemplate;
            }
    }
    return template;
};
const ArticleGrid = (props)=>{
    const { articles , setOffsetArticle , offsetArticle , isLoadingMoreArticles , templateType , itemPerPage =6 , showLoadMore =true  } = props;
    const windowSize = (0,useWindowSize/* useWindowSize */.i)();
    const handleCards = ()=>{
        const maxTotalRows = articles.length;
        const cards = [];
        let articleIndex = 0;
        const cardTemplate = getTemplate(templateType, windowSize);
        for(let rowNumber = 0; rowNumber < maxTotalRows; rowNumber += 1){
            const templateIndex = rowNumber % cardTemplate.length;
            const templateRow = cardTemplate[templateIndex];
            if (articleIndex >= maxTotalRows) {
                break;
            }
            for(let colNumber = 0; colNumber < templateRow.length; colNumber++){
                const cartType = templateRow[colNumber];
                if (articleIndex >= maxTotalRows) {
                    break;
                }
                const article = articles[articleIndex];
                if (cartType === CardType.SMALL) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                        type: article_card/* ArticleCardType.Small */._.Small,
                        article: article
                    }, "article_card_".concat(article.id)));
                }
                if (cartType === CardType.LARGE) {
                    cards.push(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (article_grid_module_default()).articleLarge,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_card/* default */.Z, {
                            type: article_card/* ArticleCardType.Large */._.Large,
                            article: article
                        })
                    }, "article_card_".concat(article.id || Math.random())));
                }
                articleIndex += 1;
            }
        }
        return cards;
    };
    const handleLoadMoreArticle = ()=>{
        const count = offsetArticle + itemPerPage;
        setOffsetArticle(count);
    };
    const renderArticleContent = ()=>{
        if (articles.length === 0 && !isLoadingMoreArticles) {
            return null;
        }
        if (articles.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_grid_skeleton, {});
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (article_grid_module_default()).articlesContainer,
            children: handleCards().map((card)=>card)
        });
    };
    const renderButtonLoadMore = ()=>{
        if (articles.length < itemPerPage || offsetArticle > articles.length) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()((article_grid_module_default()).buttonLoadMore, {
                [(article_grid_module_default()).loading]: isLoadingMoreArticles,
                [(article_grid_module_default()).loaded]: !isLoadingMoreArticles
            }),
            onClick: ()=>handleLoadMoreArticle(),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (article_grid_module_default()).buttonLoadMoreContent,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Load more"
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (article_grid_module_default()).articleGrid,
        children: [
            renderArticleContent(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (article_grid_module_default()).loadMoreContainer,
                children: [
                    showLoadMore && renderButtonLoadMore(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((article_grid_module_default()).spinnerLoadMore, {
                            [(article_grid_module_default()).loading]: isLoadingMoreArticles,
                            [(article_grid_module_default()).loaded]: !isLoadingMoreArticles
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var article_grid = (ArticleGrid);


/***/ }),

/***/ 6940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ default_layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(5407);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2991);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Icon/index.tsx + 74 modules
var Icon = __webpack_require__(2532);
// EXTERNAL MODULE: ./components/dropdown-selector/dropdown-selector.module.scss
var dropdown_selector_module = __webpack_require__(8099);
var dropdown_selector_module_default = /*#__PURE__*/__webpack_require__.n(dropdown_selector_module);
;// CONCATENATED MODULE: ./components/dropdown-selector/dropdown-selector.tsx





const Dropdown = (props)=>{
    const { defaultValue , dropdownData , onChange  } = props;
    const [isDropdownOpen, setOpen] = (0,react.useState)(false);
    const [selectedItem, setSelectedItem] = (0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.id) || dropdownData[0].id);
    if (!dropdownData) {
        return null;
    }
    const handleItemClick = (id)=>{
        selectedItem == id ? setSelectedItem(null) : setSelectedItem(id);
        setOpen(!isDropdownOpen);
        if (onChange) {
            const selectedItem1 = dropdownData.find((item)=>item.id === id);
            onChange(selectedItem1);
        }
    };
    const classDropdownWrapper = classnames_default()({
        "dropdown-warpper": true
    });
    const classDropdownHeader = classnames_default()({
        "dropdown-header": true,
        "dropdown-open": isDropdownOpen
    });
    const classDropdownBody = classnames_default()({
        "dropdown-body": true,
        "dropdown-open": isDropdownOpen
    });
    const classIconRight = classnames_default()({
        "icon-right": true,
        "icon-open": isDropdownOpen
    });
    const renderDefaultItem = (selectedItem)=>{
        if (selectedItem) {
            const defaultItem = dropdownData.find((item)=>item.id == selectedItem);
            return defaultItem === null || defaultItem === void 0 ? void 0 : defaultItem.label;
        } else return dropdownData[0].label;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (dropdown_selector_module_default()).dropdownSelector + " " + classDropdownWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classDropdownHeader,
                onClick: ()=>setOpen(!isDropdownOpen),
                children: [
                    renderDefaultItem(selectedItem),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classIconRight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            type: Icon/* IconType.Down */.T.Down
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classDropdownBody,
                onClick: ()=>setOpen(false),
                children: [
                    ...dropdownData || []
                ].map((item)=>{
                    if (item.id !== selectedItem) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "dropdown-item",
                            id: item.id.toString(),
                            onClick: (e)=>handleItemClick(e.target.id),
                            children: item.label
                        }, item.id);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var dropdown_selector = (Dropdown);

// EXTERNAL MODULE: ./helpers/LangHelper.ts
var LangHelper = __webpack_require__(7868);
// EXTERNAL MODULE: ./shared/env.ts
var env = __webpack_require__(9771);
;// CONCATENATED MODULE: ./helpers/NavHelper.ts

var NavItemLocations;
(function(NavItemLocations) {
    NavItemLocations["App"] = "App";
    NavItemLocations["AppChips"] = "App Chips";
    NavItemLocations["AllCategories"] = "All Categories";
    NavItemLocations["Retailers"] = "Retailers";
    NavItemLocations["WebTop"] = "Web top";
    NavItemLocations["Footer"] = "Footer";
    NavItemLocations["FooterRegional"] = "Regional Footer";
})(NavItemLocations || (NavItemLocations = {}));
const cachedFetchedFooterItems = {};
const cachedFetchedHeaderItems = {};
const NAVIGATION_ENDPOINT = "".concat(env/* STORE_API_URL */.ps, "/v1/navigations?locale=");
const ALL_NAVIGATION_ITEMS_ENDPOINT = "".concat(env/* STORE_API_URL */.ps, "/v1/navigation_items?locale=");
const storeFetchAPIPromise = {};
const storeFetchHeaderAPIPromise = {};
const fetchNavigations = async (locale)=>{
    try {
        const response = await fetch(NAVIGATION_ENDPOINT + locale);
        return await response.json();
    } catch (err) {
        console.error(err);
        return {
            data: [],
            included: []
        };
    }
};
const fetchAllNavigationItems = async (locale)=>{
    try {
        const response = await fetch(ALL_NAVIGATION_ITEMS_ENDPOINT + locale);
        return (await response.json()).data;
    } catch (err) {
        console.error(err);
        return [];
    }
};
async function fetchGlobalNavItems(locale) {
    if (storeFetchAPIPromise[locale]) {
        return await storeFetchAPIPromise[locale];
    }
    if (cachedFetchedFooterItems[locale]) {
        return cachedFetchedFooterItems[locale];
    }
    storeFetchAPIPromise[locale] = (async ()=>{
        const response = await fetchNavigations(locale);
        const { items , regionalItems  } = getNavMatrix(response, NavItemLocations.Footer, NavItemLocations.FooterRegional);
        return [
            items,
            regionalItems
        ];
    })();
    const response = await storeFetchAPIPromise[locale];
    delete storeFetchAPIPromise[locale];
    cachedFetchedFooterItems[locale] = response;
    return response;
}
async function fetchHeaderNavItems(locale) {
    if (storeFetchHeaderAPIPromise[locale]) {
        return await storeFetchHeaderAPIPromise[locale] || [];
    }
    if (cachedFetchedHeaderItems[locale]) {
        return cachedFetchedHeaderItems[locale] || [];
    }
    storeFetchHeaderAPIPromise[locale] = (async ()=>{
        const allCategoriesNavItem = await getNavigationItemByName(NavItemLocations.AllCategories, locale);
        const allCategoriesItems = await fetchAllNavigationItems(locale);
        const allCategoriesSubMenuItems = allCategoriesItems.filter((item)=>{
            return String(item.attributes.navigation_id) === (allCategoriesNavItem === null || allCategoriesNavItem === void 0 ? void 0 : allCategoriesNavItem.id);
        });
        const allCategoriesChunks = chunkNavigationItems(allCategoriesSubMenuItems);
        const webTopNavItems = await fetchNavigation(NavItemLocations.WebTop, locale);
        return [
            [
                allCategoriesNavItem,
                allCategoriesChunks
            ],
            ...webTopNavItems
        ];
    })();
    const response = await storeFetchHeaderAPIPromise[locale];
    delete storeFetchHeaderAPIPromise[locale];
    cachedFetchedHeaderItems[locale] = response;
    return response || [];
}
const getNavMatrix = (data, navName, navNameLocation)=>{
    const regionalItems = {};
    const items = {};
    let regionNavID;
    let navID;
    // we only care about Footer & Regional footer, so let's start by filtering the pool
    data.data.forEach((item)=>{
        if (item.attributes.name === navName) {
            navID = parseInt(item.id);
        } else if (navNameLocation && item.attributes.name === navNameLocation) {
            regionNavID = parseInt(item.id);
        }
    });
    const mappedNavItems = {};
    data.included.forEach((item)=>{
        if ([
            regionNavID,
            navID
        ].includes(item.attributes.navigation_id)) {
            mappedNavItems[item.id] = item;
        }
    });
    const placeNavItemInMatrix = function(item) {
        let isRegional = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        const matrix = isRegional ? regionalItems : items;
        if (matrix[item.attributes.column] === undefined) {
            matrix[item.attributes.column] = {};
        }
        let targetColumn;
        let targetRow;
        let isLead = false;
        if (item.attributes.parent_id) {
            const parentItem = mappedNavItems[item.attributes.parent_id];
            if (!matrix[parentItem.attributes.column][parentItem.attributes.row]) {
                placeNavItemInMatrix(parentItem, isRegional);
            }
            targetColumn = parentItem.attributes.column;
            targetRow = item.attributes.row + 1;
        } else {
            targetColumn = item.attributes.column;
            targetRow = item.attributes.row;
            if (!isRegional) {
                isLead = true;
            }
        }
        matrix[targetColumn][targetRow] = {
            name: item.attributes.title,
            id: item.id,
            link: item.attributes.link,
            children: [],
            isLead
        };
    };
    Object.values(mappedNavItems).forEach((item)=>{
        placeNavItemInMatrix(item, item.attributes.navigation_id == regionNavID);
    });
    return {
        regionalItems,
        items
    };
};
const byColumn = (a, b)=>{
    var ref, ref1;
    return (a === null || a === void 0 ? void 0 : (ref = a.attributes) === null || ref === void 0 ? void 0 : ref.column) > (b === null || b === void 0 ? void 0 : (ref1 = b.attributes) === null || ref1 === void 0 ? void 0 : ref1.column) ? 1 : -1;
};
const fetchNavigation = async (name, locale)=>{
    const navigations = await fetchNavigations(locale);
    const navigation = navigations.data.find((nav)=>nav.attributes.name === name);
    if (!navigation) {
        throw new Error('Unable to find a navigation with name "'.concat(name, '"'));
    }
    const allNavigationItems = await fetchAllNavigationItems(locale);
    const allNavigationItemsById = allNavigationItems.reduce((accum, item)=>({
            ...accum,
            [item.id]: item
        }), {});
    const { data  } = navigation.relationships.navigation_items;
    const topLevelNavigationItems = allNavigationItems.filter((param)=>{
        let { attributes: { parent_id  }  } = param;
        return parent_id === null;
    }).filter((param)=>{
        let { id  } = param;
        return data.find((n)=>n.id === id);
    }).sort(byColumn);
    return topLevelNavigationItems.map((topLevelNavItem)=>{
        const { data: childNavItems  } = topLevelNavItem.relationships.sub_navigation_items;
        const genericTopLevelNavItem = {
            id: topLevelNavItem.id,
            text: topLevelNavItem.attributes.title,
            categoryId: topLevelNavItem.attributes.category_id,
            bold: topLevelNavItem.attributes.bold,
            color: topLevelNavItem.attributes.color,
            link: navLink(topLevelNavItem.attributes.link, topLevelNavItem.attributes.category_id)
        };
        const matchingChildNavItems = childNavItems.reduce((accum, item)=>{
            if (allNavigationItemsById[item.id]) {
                accum.push(allNavigationItemsById[item.id]);
            }
            return accum;
        }, []);
        const genericChildNavItemChunks = chunkNavigationItems(matchingChildNavItems);
        return [
            genericTopLevelNavItem,
            genericChildNavItemChunks
        ];
    });
};
const chunkNavigationItems = (subMenuItems)=>{
    return subMenuItems.reduce((accum, element)=>{
        const { column , row  } = element.attributes;
        if (!Array.isArray(accum[column])) {
            accum[column] = [];
        }
        var _title;
        accum[column][row] = {
            id: element.id,
            text: (_title = element.attributes.title) !== null && _title !== void 0 ? _title : "",
            categoryId: element.attributes.category_id,
            bold: element.attributes.bold,
            color: element.attributes.color,
            link: navLink(element.attributes.link, element.attributes.category_id)
        };
        return accum;
    }, []).reduce((accum, chunk)=>{
        const chunkWithoutEmptyValues = chunk.filter((navItem)=>!!navItem);
        return [
            ...accum,
            chunkWithoutEmptyValues
        ];
    }, []).filter((chunks)=>{
        return (chunks === null || chunks === void 0 ? void 0 : chunks.length) > 0;
    });
};
const navLink = (link, categoryId)=>{
    if (!link) return "";
    // TODO: we need to come up with a better way to handle fully qualified URLs from the CMS
    // and how we handle sharing those URLs between environments with different origins
    const afterpaySiteRegex = new RegExp("^(https?://)?(www.)?afterpay.com");
    const clearpayEUSiteRegex = new RegExp("^(https?://)?(www.)?clearpay.com");
    const clearpayGBSiteRegex = new RegExp("^(https?://)?(www.)?clearpay.co.uk");
    const isFullyQualified = afterpaySiteRegex.test(link);
    const isFullyQualifiedClearpayEU = clearpayEUSiteRegex.test(link);
    const isFullyQualifiedClearpayGB = clearpayGBSiteRegex.test(link);
    if (isFullyQualified) {
        return link.replace(afterpaySiteRegex, "");
    } else if (isFullyQualifiedClearpayEU) {
        return link.replace(clearpayEUSiteRegex, "");
    } else if (isFullyQualifiedClearpayGB) {
        return link.replace(clearpayGBSiteRegex, "");
    }
    return link && categoryId ? "/categories".concat(link) : link;
};
const getNavigationItemByName = async (name, locale)=>{
    const allCategoriesNavigation = await fetchNavigations(locale);
    const matchingNavItem = allCategoriesNavigation.data.find((nav)=>nav.attributes.name === name);
    if (!matchingNavItem) {
        return null;
    }
    return {
        id: matchingNavItem.id,
        text: getTranslatedCategories(locale) || name,
        categoryId: null,
        bold: false,
        color: {
            name: "black",
            hexCode: "#000000"
        },
        link: "/categories"
    };
};
const getTranslatedCategories = (locale)=>{
    switch(locale){
        case "en-US":
        case "en-AU":
        case "en-NZ":
        case "en-CA":
        case "en-GB":
            return "All Categories";
        case "fr-CA":
            return "Toutes les Cat\xe9gories";
        default:
            return "";
    }
};

// EXTERNAL MODULE: ./modules/pages/footer/footer.module.scss
var footer_module = __webpack_require__(5867);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./modules/pages/footer/index.tsx








const renderSingleBlock = (footerCategoryItems)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (footer_module_default()).footerBlock,
        children: footerCategoryItems.map((item, index)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: item.isLead ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (footer_module_default()).footerTitle,
                    children: item.title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: item.url,
                    target: "_self",
                    children: item.title
                })
            }, "footer_item_".concat(index));
        })
    });
};
const Footer = (props)=>{
    var ref, ref1, ref2, ref3, ref4;
    const route = (0,next_router.useRouter)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    var _footerData;
    const [footerItems, setFooterItems] = (0,react.useState)((_footerData = props.footerData) !== null && _footerData !== void 0 ? _footerData : []);
    (0,react.useEffect)(()=>{
        if (!props.footerData) {
            let cancelled = false;
            fetchGlobalNavItems(locale).then((items)=>{
                if (!cancelled) {
                    setFooterItems(items);
                }
            });
            return ()=>{
                cancelled = true;
            };
        }
    }, []);
    const handleOnLocationChange = (location)=>{
        if (!location) return;
        const locale = location.id;
        const oldLocale = (0,LangHelper/* getLocaleFromRoute */._y)(route.asPath);
        let newUrl = route.asPath.replace(oldLocale, locale);
        if (newUrl.indexOf(locale) < 0) {
            newUrl = (0,LangHelper/* replaceOrAddLocale */.yM)(newUrl, locale);
        }
        var _urlRedirect;
        window.location.href = (_urlRedirect = location.urlRedirect) !== null && _urlRedirect !== void 0 ? _urlRedirect : newUrl;
    };
    const dropdownOptions = LangHelper/* LIVE_LOCALES.map */.Fw.map((thisLocale)=>{
        var ref;
        return {
            id: thisLocale,
            label: (0,LangHelper/* getLocalePrettyName */.FZ)(thisLocale),
            urlRedirect: "/".concat(thisLocale, "/").concat((ref = LangHelper/* LOCALE_LINKS */.kV[thisLocale]) === null || ref === void 0 ? void 0 : ref.contentHubRoot)
        };
    });
    const getDefaultLocaleOption = ()=>dropdownOptions.find((option)=>option.id === locale);
    if (!footerItems || footerItems.length < 1) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (footer_module_default()).footerContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_module_default()).footerDivider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_module_default()).footerInner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (footer_module_default()).footerTop,
                        children: [
                            (ref = Object.values(footerItems[0])) === null || ref === void 0 ? void 0 : ref.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: renderSingleBlock(Object.values(item).map((item)=>({
                                            title: item.name,
                                            url: item.link,
                                            isLead: item.isLead
                                        })))
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_module_default()).footerLocation,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_module_default()).footerTitle,
                                        children: "Location"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown_selector, {
                                        defaultValue: getDefaultLocaleOption(),
                                        dropdownData: dropdownOptions,
                                        onChange: handleOnLocationChange
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (footer_module_default()).footerBottom,
                        children: [
                            (ref1 = Object.values(footerItems[1])) === null || ref1 === void 0 ? void 0 : ref1.map((item, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                    children: renderSingleBlock(Object.values(item).map((item)=>({
                                            title: item.name,
                                            url: item.link,
                                            isLead: item.isLead
                                        })))
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_module_default()).legalText,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: ((ref2 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref2 === void 0 ? void 0 : ref2.legal.line1) || ""
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        dangerouslySetInnerHTML: {
                                            __html: ((ref3 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref3 === void 0 ? void 0 : ref3.legal.line2) || ""
                                        }
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: (ref4 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref4 === void 0 ? void 0 : ref4.home,
                        target: "_self",
                        className: (footer_module_default()).logoAfterPay,
                        children: locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            type: Icon/* IconType.LogoClearpay */.T.LogoClearpay
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                            type: Icon/* IconType.Afterpay */.T.Afterpay
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(8046);
// EXTERNAL MODULE: ./modules/pages/navigation/Auth/Auth.module.scss
var Auth_module = __webpack_require__(6358);
var Auth_module_default = /*#__PURE__*/__webpack_require__.n(Auth_module);
;// CONCATENATED MODULE: ./modules/pages/navigation/Auth/index.tsx




const Auth = ()=>{
    var ref;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const portal = (ref = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref === void 0 ? void 0 : ref.portal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Auth_module_default()).authcontainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Auth_module_default()).ctaContainer,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Auth_module_default()).buttonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: (Auth_module_default()).buttonsIcon,
                        href: "".concat(portal === null || portal === void 0 ? void 0 : portal.home).concat(portal === null || portal === void 0 ? void 0 : portal.login),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                type: Icon/* IconType.Profile */.T.Profile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (Auth_module_default()).loginButtonLabel,
                                children: "Login"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Auth_module_default()).buttonContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: (Auth_module_default()).buttonsNavigation,
                        href: "".concat(portal === null || portal === void 0 ? void 0 : portal.home).concat(portal === null || portal === void 0 ? void 0 : portal.signup),
                        children: "Sign Up"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navigation_Auth = (Auth);

// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(7060);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./modules/pages/navigation/MobileNavigation/mobileNavigation.module.scss
var mobileNavigation_module = __webpack_require__(3406);
var mobileNavigation_module_default = /*#__PURE__*/__webpack_require__.n(mobileNavigation_module);
;// CONCATENATED MODULE: ./modules/pages/navigation/MobileNavigation/MobileNavigationFooter/index.tsx





const MobileNavigationFooter = (props)=>{
    var ref, ref1, ref2, ref3;
    const { navigationItems =[
        [],
        []
    ]  } = props;
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (mobileNavigation_module_default()).mobileNavigationFooterContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (mobileNavigation_module_default()).footerNavigationItemsContainer,
                children: (ref = Object.values(navigationItems[1])) === null || ref === void 0 ? void 0 : ref.map(Object.values).flat().map((item)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobileNavigation_module_default()).footerNavigationItem,
                        children: item.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: item.link,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: item.name
                            })
                        }) : item.name
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (mobileNavigation_module_default()).footerInformationContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobileNavigation_module_default()).footerLogo,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: (ref1 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref1 === void 0 ? void 0 : ref1.home,
                            target: "_self",
                            className: (mobileNavigation_module_default()).logoAfterPay,
                            children: locale === LangHelper/* Locale.GreatBritain */.go.GreatBritain ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                type: Icon/* IconType.LogoClearpay */.T.LogoClearpay
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                type: Icon/* IconType.LogoAfterPay */.T.LogoAfterPay
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (mobileNavigation_module_default()).footerServiceContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: ((ref2 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref2 === void 0 ? void 0 : ref2.legal.line1) || ""
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: ((ref3 = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref3 === void 0 ? void 0 : ref3.legal.line2) || ""
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./shared/constants.ts
var constants = __webpack_require__(8362);
;// CONCATENATED MODULE: ./modules/pages/navigation/MobileNavigation/MobileNavigationItem/index.tsx






const cx = bind_default().bind((mobileNavigation_module_default()));
const renderSubmenu = (subMenuItemChunks)=>{
    return subMenuItemChunks.map((chunk, index)=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
            className: (mobileNavigation_module_default()).mobileNavigationSubMenu,
            children: chunk.map((param)=>{
                let { id , text , link , bold , color  } = param;
                const mobileNavigationItemClassName = cx({
                    [(mobileNavigation_module_default()).mobileNavigationSubMenuItem]: true,
                    [(mobileNavigation_module_default()).mobileNavigationSubMenuItemBold]: bold,
                    [(mobileNavigation_module_default()).mobileNavigationSubMenuItemBlack]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.BLACK */.HZ.BLACK,
                    [(mobileNavigation_module_default()).mobileNavigationSubMenuItemFire]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.FIRE */.HZ.FIRE,
                    [(mobileNavigation_module_default()).mobileNavigationSubMenuItemOrca]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.ORCA */.HZ.ORCA
                });
                if (!link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: mobileNavigationItemClassName,
                        children: text
                    }, id);
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: mobileNavigationItemClassName,
                    children: text
                }, id);
            })
        }, "submenu-".concat(index));
    });
};
const MobileNavigationItem = (props)=>{
    const { text , subMenuItemChunks , url  } = props;
    const [isMenuItemActive, setIsMenuItemActive] = (0,react.useState)(false);
    const mobileNavigationItemClassName = cx({
        [(mobileNavigation_module_default()).mobileNavigationItem]: true
    });
    const mobileNavigationChevronClassName = cx({
        [(mobileNavigation_module_default()).mobileNavigationChevron]: subMenuItemChunks.length,
        [(mobileNavigation_module_default()).mobileNavigationChevronActive]: isMenuItemActive
    });
    const mobileNavigationSubMenuContainerClassName = cx({
        [(mobileNavigation_module_default()).mobileNavigationSubMenuContainer]: true
    });
    const onClick = ()=>{
        setIsMenuItemActive(!isMenuItemActive);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: mobileNavigationItemClassName,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        role: "button",
                        href: url,
                        children: text
                    }),
                    subMenuItemChunks && (subMenuItemChunks.length || null) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (mobileNavigation_module_default()).mobileNavigationChevronContainer,
                        onClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: mobileNavigationChevronClassName,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                type: Icon/* IconType.Right */.T.Right
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: mobileNavigationSubMenuContainerClassName,
                children: isMenuItemActive && renderSubmenu(subMenuItemChunks)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./modules/pages/navigation/MobileNavigation/index.tsx





const MobileNavigation_cx = bind_default().bind((mobileNavigation_module_default()));
const MobileNavigation = (props)=>{
    const { navigationItems , footerItems , isMobileMenuActive  } = props;
    const mobileNavigationContainerClassName = MobileNavigation_cx({
        [(mobileNavigation_module_default()).mobileNavigationContainer]: true,
        [(mobileNavigation_module_default()).mobileNavigationContainerActive]: isMobileMenuActive
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: mobileNavigationContainerClassName,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (mobileNavigation_module_default()).mobileNavigationContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((param, index)=>/*#__PURE__*/ {
                        let [navItem, subNavItems] = param;
                        return (0,jsx_runtime.jsx)(MobileNavigationItem, {
                            text: navItem.text,
                            url: navItem.link,
                            subMenuItemChunks: subNavItems
                        }, "".concat(navItem.id, "-").concat(index));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (mobileNavigation_module_default()).mobileNavigationDivider
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavigationFooter, {
                    navigationItems: footerItems
                })
            ]
        })
    });
};
/* harmony default export */ var navigation_MobileNavigation = (MobileNavigation);

// EXTERNAL MODULE: ./modules/pages/navigation/navigation.module.scss
var navigation_module = __webpack_require__(2125);
var navigation_module_default = /*#__PURE__*/__webpack_require__.n(navigation_module);
// EXTERNAL MODULE: ./modules/pages/navigation/SearchBar/search-bar.module.scss
var search_bar_module = __webpack_require__(8163);
var search_bar_module_default = /*#__PURE__*/__webpack_require__.n(search_bar_module);
// EXTERNAL MODULE: ./node_modules/@react-hook/debounce/dist/module/index.js + 1 modules
var dist_module = __webpack_require__(530);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
// EXTERNAL MODULE: ./node_modules/react-lottie-player/dist/LottiePlayer.modern.js
var LottiePlayer_modern = __webpack_require__(2058);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(2374);
;// CONCATENATED MODULE: ./assets/animations/mint-logo-transparent-bg.json
var mint_logo_transparent_bg_namespaceObject = JSON.parse('{"v":"5.5.7","meta":{"g":"LottieFiles AE 0.1.20","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":226,"w":474,"h":420,"nm":"Mark - Mint on transparent background","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"bottom mask","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[136.556,277.543,0],"ix":2},"a":{"a":0,"k":[907.135,575.549,0],"ix":1},"s":{"a":0,"k":[190,190,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[13.563,-23.377],[0.669,-3.915],[12.275,5.787],[28.885,17.493],[-11.416,9.002],[-7.574,3.451],[-2.049,0.393],[-3.219,-1.001],[0.21,-10.663],[-0.162,-1.74]],"o":[[-2.745,4.731],[-2.286,13.376],[-10.934,-5.155],[-12.436,-7.531],[19.64,-15.488],[1.898,-0.865],[3.445,-0.661],[6.515,2.026],[-0.029,1.481],[0,0]],"v":[[56.051,23.246],[52.287,42.322],[23.186,57.062],[-46.347,18.026],[-47.836,-16.044],[19.781,-55.498],[25.709,-57.395],[37.697,-58.781],[51.429,-40.443],[51.624,-34.549]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.815686285496,0,0.109803922474,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":33,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[907.135,575.549],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"bottom mask","np":1,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.924],"y":[1]},"o":{"x":[0.823],"y":[0]},"t":1,"s":[0]},{"i":{"x":[0.924],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":60,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":120,"s":[100]},{"t":180,"s":[0]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":39600,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":".logo-mark-bottom","cl":"logo-mark-bottom","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[237,210,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[190,190,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[23.342,13.393],[0,0],[0,0],[0,-26.786],[0,0],[-2.142,-1.229],[0,0],[0,5.202],[0,0],[-4.592,-2.634],[0,0],[0,0],[4.613,-2.647],[0,0],[0,0],[0,5.294],[0,0],[23.233,-13.33],[0,0],[0,0],[-23.342,-13.393],[0,0],[0,0],[0,26.786],[0,0],[2.142,1.229],[0,0],[0,-5.202],[0,0],[4.592,2.634],[0,0],[0,0],[-4.613,2.647],[0,0],[0,0],[0,-5.294],[0,0],[-23.233,13.33],[0,0],[0,0]],"o":[[0,0],[0,0],[-23.233,-13.33],[0,0],[0,2.47],[0,0],[4.512,2.589],[0,0],[0,-5.294],[0,0],[0,0],[4.613,2.647],[0,0],[0,0],[-4.592,2.634],[0,0],[0.001,-26.786],[0,0],[0,0],[-23.342,13.393],[0,0],[0,0],[23.233,13.33],[0,0],[0,-2.47],[0,0],[-4.512,-2.589],[0,0],[0,5.294],[0,0],[0,0],[-4.613,-2.647],[0,0],[0,0],[4.592,-2.634],[0,0],[0,26.786],[0,0],[0,0],[23.342,-13.393]],"v":[[106.878,-65.911],[72.316,-85.741],[37.263,-105.853],[-14.93,-75.625],[-14.93,-71.111],[-11.467,-65.131],[4.795,-55.8],[14.93,-61.67],[14.93,-72.361],[25.245,-78.335],[57.282,-59.954],[89.221,-41.628],[89.221,-29.68],[57.282,-11.355],[25.245,7.026],[14.93,1.052],[14.931,-4.259],[-37.262,-34.487],[-72.316,-14.375],[-106.878,5.455],[-106.878,65.911],[-72.316,85.741],[-37.263,105.853],[14.931,75.625],[14.931,71.1],[11.467,65.12],[-4.795,55.789],[-14.93,61.659],[-14.93,72.361],[-25.245,78.335],[-57.282,59.953],[-89.221,41.628],[-89.221,29.68],[-57.282,11.355],[-25.245,-7.027],[-14.93,-1.053],[-14.93,4.259],[37.263,34.486],[72.316,14.375],[106.878,-5.455]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.698039233685,0.988235294819,0.89411765337,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":5,"op":246,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"top mask","td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[337.51,141.632,0],"ix":2},"a":{"a":0,"k":[1013.426,504.017,0],"ix":1},"s":{"a":0,"k":[190,190,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-6.554,11.526],[0,0],[-7.276,-3.55],[-15.349,-11.436],[8.827,-7.093],[15.167,-7.437],[7.815,9.511],[0.48,5.149]],"o":[[3.524,-6.197],[4.621,-6.648],[20.861,10.179],[9.08,6.766],[-17.375,13.962],[-11.053,5.419],[-2.436,-2.965],[0,0]],"v":[[-55.49,-23.269],[-51.271,-51.602],[-25.602,-56.988],[48.524,-15.189],[49.021,14.186],[-21.062,55.588],[-50.397,49.816],[-54.667,34.983]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.815686285496,0,0.109803922474,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":33,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tr","p":{"a":0,"k":[1013.426,504.017],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"top mask","np":1,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.924],"y":[1]},"o":{"x":[0.823],"y":[0]},"t":1,"s":[0]},{"i":{"x":[0.924],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":60,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":120,"s":[100]},{"t":180,"s":[0]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":39600,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":".logo-mark-top","cl":"logo-mark-top","tt":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[237,210,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[190,190,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[23.342,13.393],[0,0],[0,0],[0,-26.786],[0,0],[-2.142,-1.229],[0,0],[0,5.202],[0,0],[-4.592,-2.634],[0,0],[0,0],[4.613,-2.647],[0,0],[0,0],[0,5.294],[0,0],[23.233,-13.33],[0,0],[0,0],[-23.342,-13.393],[0,0],[0,0],[0,26.786],[0,0],[2.142,1.229],[0,0],[0,-5.202],[0,0],[4.592,2.634],[0,0],[0,0],[-4.613,2.647],[0,0],[0,0],[0,-5.294],[0,0],[-23.233,13.33],[0,0],[0,0]],"o":[[0,0],[0,0],[-23.233,-13.33],[0,0],[0,2.47],[0,0],[4.512,2.589],[0,0],[0,-5.294],[0,0],[0,0],[4.613,2.647],[0,0],[0,0],[-4.592,2.634],[0,0],[0.001,-26.786],[0,0],[0,0],[-23.342,13.393],[0,0],[0,0],[23.233,13.33],[0,0],[0,-2.47],[0,0],[-4.512,-2.589],[0,0],[0,5.294],[0,0],[0,0],[-4.613,-2.647],[0,0],[0,0],[4.592,-2.634],[0,0],[0,26.786],[0,0],[0,0],[23.342,-13.393]],"v":[[106.878,-65.911],[72.316,-85.741],[37.263,-105.853],[-14.93,-75.625],[-14.93,-71.111],[-11.467,-65.131],[4.795,-55.8],[14.93,-61.67],[14.93,-72.361],[25.245,-78.335],[57.282,-59.954],[89.221,-41.628],[89.221,-29.68],[57.282,-11.355],[25.245,7.026],[14.93,1.052],[14.931,-4.259],[-37.262,-34.487],[-72.316,-14.375],[-106.878,5.455],[-106.878,65.911],[-72.316,85.741],[-37.263,105.853],[14.931,75.625],[14.931,71.1],[11.467,65.12],[-4.795,55.789],[-14.93,61.659],[-14.93,72.361],[-25.245,78.335],[-57.282,59.953],[-89.221,41.628],[-89.221,29.68],[-57.282,11.355],[-25.245,-7.027],[-14.93,-1.053],[-14.93,4.259],[37.263,34.486],[72.316,14.375],[106.878,-5.455]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.698039233685,0.988235294819,0.89411765337,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":5,"op":230,"st":0,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/no-result.tsx



const OptionListNoResults = (param)=>{
    let { noResultsText  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (search_bar_module_default()).resultNotFound,
        children: noResultsText
    });
};

;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/search-bar.constants.ts
const SEARCH_VERSION = {
    TWO: "2",
    THREE: "3"
};
const CATEGORY_SUGGESTION_START_INDEX = 9;
const SEARCH_PAGE_COR_ID_COOKIE_KEY = "S_COR_ID";
const CORE_SITE_DOMAIN = "https://afterpay.com";
const CORRELATION_ID_HEADER_KEY = "correlation-id";
const REQUEST_ID_STORE_KEY = "req-id";
const filterByName = (results, userInput)=>{
    return results === null || results === void 0 ? void 0 : results.filter((obj)=>{
        return obj === null || obj === void 0 ? void 0 : obj.name.toLowerCase().includes(userInput.toLowerCase());
    });
};

;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/suggestion-heading.tsx



const SuggestionHeading = (param)=>/*#__PURE__*/ {
    let { text  } = param;
    return (0,jsx_runtime.jsx)("h2", {
        className: (search_bar_module_default()).searchBarSuggestionHeading,
        children: text
    });
};

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(6224);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: async_hooks (ignored)
var async_hooks_ignored_ = __webpack_require__(3427);
;// CONCATENATED MODULE: ./modules/pages/navigation/utils/continuation-local-storage.ts



const browserAsyncLocalStorageMock = {
    run: (o, callback)=>callback(),
    getStore: ()=>null,
    enterWith: ()=>false
};
const generateUUID = ()=>{
    return "generated-id-".concat((0,v4/* default */.Z)());
};
const asyncLocalStorage = async_hooks_ignored_.AsyncLocalStorage ? new async_hooks_ignored_.AsyncLocalStorage() : browserAsyncLocalStorageMock;
const getContinuationStore = ()=>{
    return asyncLocalStorage.getStore();
};
const getContinuationRequestId = function() {
    let forceGenerateID = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref;
    const fallbackRequestId = forceGenerateID ? generateUUID() : null;
    const store = getContinuationStore();
    return ((ref = store === null || store === void 0 ? void 0 : store.get(REQUEST_ID_STORE_KEY)) === null || ref === void 0 ? void 0 : ref.toString()) || fallbackRequestId;
};

;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/useAutocomplete.ts





const apiPrefix = env/* isProd */.BB ? "/api" : env/* PROXY_URL */.NM;
axios_default().interceptors.request.use((request)=>{
    const corelationId = getContinuationRequestId(true);
    if (request.headers) {
        request.headers[CORRELATION_ID_HEADER_KEY] = corelationId;
    }
    return request;
});
async function fetcher(url, httpCorrelationId) {
    const res = await axios_default()({
        url,
        method: "GET",
        headers: {
            "cor-id": httpCorrelationId
        }
    });
    return res.data;
}
function useAutocomplete(searchTerm, httpCorrelationId, locale, searchVersion) {
    const url = "".concat(apiPrefix, "/stores/autocomplete?").concat("q=".concat(encodeURIComponent(searchTerm), "&locale=").concat(locale, "&search_version=").concat(searchVersion));
    const { data: autocompleteData  } = (0,dist/* default */.ZP)(searchTerm ? [
        url,
        httpCorrelationId
    ] : null, fetcher);
    return autocompleteData;
}

;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/search-bar-v3.tsx















const search_bar_v3_cx = bind_default().bind((search_bar_module_default()));
const highlightStores = (name, highlightString)=>{
    const splitStoreName = name.split(highlightString);
    if (splitStoreName.length === 1) return name;
    return splitStoreName.flatMap((split, index)=>{
        return [
            split,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (search_bar_module_default()).storeNameHighlighted,
                children: highlightString
            }, "".concat(name, "-").concat(index))
        ];
    }).slice(0, -1);
};
const SuggestionList = (param)=>{
    let { data , searchUrlLink , highlightString  } = param;
    const suggestionName = highlightString ? highlightStores(data.name, highlightString) : data.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (search_bar_module_default()).searchBarSuggestionOption,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: searchUrlLink,
            children: suggestionName
        })
    }, data.name);
};
const SuggestionMoreLink = (param)=>{
    let { searchUrl , searchTerms  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (search_bar_module_default()).searchBarSuggestionSeeMoreLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: "".concat(searchUrl, "?search_version=").concat(SEARCH_VERSION.THREE, "&q=").concat(encodeURIComponent(searchTerms)),
            children: "See more results"
        })
    });
};
const CategoriesOptionList = (param)=>{
    let { categories , searchUrl , activeSuggestedResult , searchTerm , httpCorrelationId  } = param;
    const listCategoriesHeadingText = "Categories", listNoCategoriesText = "No categories found";
    const categoriesSearchResults = categories.length > 0 ? categories.map((category, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionList, {
            data: category,
            searchUrlLink: "".concat(searchUrl, "/").concat(category.slug),
            searchTerm: searchTerm,
            activeSuggestedResult: activeSuggestedResult,
            index: index + CATEGORY_SUGGESTION_START_INDEX,
            httpCorrelationId: httpCorrelationId,
            resultsCount: categories.length
        }, category.id)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionListNoResults, {
        noResultsText: listNoCategoriesText
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionHeading, {
                text: listCategoriesHeadingText
            }),
            categoriesSearchResults
        ]
    });
};
const StoresOptionList = (param)=>{
    let { stores , searchUrl , highlightString , activeSuggestedResult , searchTerm , httpCorrelationId  } = param;
    const listStoresHeadingText = "Stores", listNoStoresText = "No stores found";
    const storesSearchResults = stores.length > 0 ? stores.slice(0, 8).map((store, index)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionList, {
            data: store,
            searchUrlLink: "".concat(searchUrl, "?search_version=").concat(SEARCH_VERSION.THREE, "&q=").concat(encodeURIComponent(store.name)),
            highlightString: highlightString,
            activeSuggestedResult: activeSuggestedResult,
            index: index,
            httpCorrelationId: httpCorrelationId,
            resultsCount: stores.length,
            searchTerm: searchTerm
        }, store.id);
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionListNoResults, {
        noResultsText: listNoStoresText
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionHeading, {
                text: listStoresHeadingText
            }),
            storesSearchResults,
            stores.length > 8 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionMoreLink, {
                searchUrl: searchUrl,
                searchTerms: highlightString
            })
        ]
    });
};
const SearchBar = ()=>{
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    //   const locale = 'en-US';
    const [{ searchTerm , httpCorrelationId  }, setSearchData] = (0,dist_module/* useDebounce */.N)({
        searchTerm: "",
        httpCorrelationId: (0,v4/* default */.Z)()
    }, 100);
    const [suggestedStores, setSuggestedStores] = (0,react.useState)([]);
    const [showSuggestionList, setShowSuggestionList] = (0,react.useState)(false);
    const [suggestedCategories, setSuggestedCategories] = (0,react.useState)([]);
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0,react.useState)(false);
    const [activeSuggestedResult, setActiveSuggestedResult] = (0,react.useState)(-1);
    const storeSearchUrl = "/".concat(locale, "/stores/search");
    const categorySearchUrl = "/".concat(locale, "/categories");
    const autocompleteData = useAutocomplete(searchTerm, httpCorrelationId, locale, SEARCH_VERSION.THREE);
    (0,react.useEffect)(()=>{
        js_cookie/* default.set */.Z.set(SEARCH_PAGE_COR_ID_COOKIE_KEY, httpCorrelationId);
    }, [
        httpCorrelationId
    ]);
    (0,react.useEffect)(()=>{
        if (autocompleteData) {
            setSuggestedStores(autocompleteData.stores);
            setSuggestedCategories(autocompleteData.categories);
            setIsLoadingSuggestions(false);
        }
    }, [
        autocompleteData
    ]);
    const onChange = (e)=>{
        const newSearchTerm = e.currentTarget.value;
        setSearchData({
            searchTerm: newSearchTerm,
            httpCorrelationId: (0,v4/* default */.Z)()
        });
        setShowSuggestionList(!!newSearchTerm);
        if (newSearchTerm) {
            setIsLoadingSuggestions(true);
        }
    };
    const onKeyDown = (e)=>{
        switch(e.key){
            case "Enter":
                {
                    if (activeSuggestedResult >= CATEGORY_SUGGESTION_START_INDEX) {
                        const highlightedIndex = activeSuggestedResult - CATEGORY_SUGGESTION_START_INDEX;
                        return router.push("/categories/".concat(suggestedCategories[highlightedIndex].slug));
                    }
                    const searchQuery = suggestedStores[activeSuggestedResult] ? suggestedStores[activeSuggestedResult].name : e.currentTarget.value;
                    return router.push("/stores/search?search_version=".concat(SEARCH_VERSION.THREE, "&q=").concat(encodeURIComponent(searchQuery)));
                }
            case "ArrowUp":
                {
                    if (activeSuggestedResult === 0) {
                        return;
                    }
                    return setActiveSuggestedResult(activeSuggestedResult - 1);
                }
            case "ArrowDown":
                {
                    if (activeSuggestedResult - 1 === suggestedStores.length) {
                        return;
                    }
                    return setActiveSuggestedResult(activeSuggestedResult + 1);
                }
        }
    };
    const suggestionListClassName = search_bar_v3_cx({
        [(search_bar_module_default()).searchBarSuggestionWrapper]: true,
        [(search_bar_module_default()).showSuggestionList]: showSuggestionList
    });
    const suggestionsListContent = isLoadingSuggestions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_bar_module_default()).loadingSpinnerContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LottiePlayer_modern/* default */.Z, {
            animationData: mint_logo_transparent_bg_namespaceObject,
            rendererSettings: {
                preserveAspectRatio: "xMidYMid slice"
            },
            loop: true,
            play: true
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresOptionList, {
                stores: suggestedStores,
                searchUrl: storeSearchUrl,
                highlightString: searchTerm,
                activeSuggestedResult: activeSuggestedResult,
                httpCorrelationId: httpCorrelationId,
                searchTerm: searchTerm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (search_bar_module_default()).optionListDivider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesOptionList, {
                categories: suggestedCategories,
                searchUrl: categorySearchUrl,
                activeSuggestedResult: activeSuggestedResult,
                httpCorrelationId: httpCorrelationId,
                searchTerm: searchTerm
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (search_bar_module_default()).searchBarWrapper,
        onFocus: ()=>{
            setShowSuggestionList(!!searchTerm);
        },
        onBlur: (e)=>{
            if (!e.currentTarget.contains(e.relatedTarget)) {
                setShowSuggestionList(false);
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                className: (search_bar_module_default()).searchInput,
                placeholder: "Search brands, products and stores",
                type: "text",
                onChange: onChange,
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                "data-testid": "search-suggestions",
                className: suggestionListClassName,
                children: suggestionsListContent
            })
        ]
    });
};
const SearchBarV3 = SearchBar;

;// CONCATENATED MODULE: ./modules/pages/navigation/SearchBar/index.tsx




const hideSearchOnTheseLocales = [
    "fr-FR",
    "es-ES",
    "it-IT"
];
const SearchBar_SearchBar = ()=>{
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    if (hideSearchOnTheseLocales.includes(locale)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (search_bar_module_default()).searchInputWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBarV3, {})
    });
};
/* harmony default export */ var navigation_SearchBar = (SearchBar_SearchBar);

;// CONCATENATED MODULE: ./modules/pages/navigation/SubNavigation/index.tsx




const SubNavigation = (param)=>{
    let { subMenuItemChunks , onMouseLeave  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (navigation_module_default()).subNavigationContainer,
        onMouseLeave: onMouseLeave,
        children: subMenuItemChunks === null || subMenuItemChunks === void 0 ? void 0 : subMenuItemChunks.filter((chunk)=>{
            return (chunk === null || chunk === void 0 ? void 0 : chunk.length) > 0;
        }).map((chunk, index)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("ul", {
                className: (navigation_module_default()).subNavigation,
                children: chunk && chunk.map((param)=>{
                    let { id , link , text , bold , color  } = param;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((navigation_module_default()).subNavigationItem, {
                            [(navigation_module_default()).subNavigationItemHeader]: !link,
                            [(navigation_module_default()).subNavigationItemHover]: link,
                            [(navigation_module_default()).subNavigationItemBold]: bold,
                            [(navigation_module_default()).subNavigationItemBlack]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.BLACK */.HZ.BLACK,
                            [(navigation_module_default()).subNavigationItemFire]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.FIRE */.HZ.FIRE,
                            [(navigation_module_default()).subNavigationItemOrca]: (color === null || color === void 0 ? void 0 : color.name) === constants/* NAVIGATION_ITEM_COLORS.ORCA */.HZ.ORCA
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            tabIndex: 0,
                            role: "button",
                            href: link,
                            className: (navigation_module_default()).navToplevelItemLink,
                            children: text
                        })
                    }, id);
                })
            }, index);
        })
    });
};
/* harmony default export */ var navigation_SubNavigation = (SubNavigation);

;// CONCATENATED MODULE: ./modules/pages/navigation/TopLevelNavigation/index.tsx





const SubNavigationItems = (param)=>{
    let { navigationItems , activeId  } = param;
    if (!activeId) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: navigationItems.filter((param)=>{
            let [navItem] = param;
            return activeId === navItem.id;
        }).map((param)=>{
            let [navItem, subNavItems] = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_SubNavigation, {
                subMenuItemChunks: subNavItems
            }, navItem.id);
        })
    });
};
const TopLevelNavigation = (param)=>{
    let { navigationItems  } = param;
    const [activeId, setActiveId] = (0,react.useState)();
    const handleKeyDown = (e, id)=>{
        if (e.key === "ArrowDown") {
            e.preventDefault();
            setActiveId(id);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (navigation_module_default()).navToplevel,
        onMouseLeave: ()=>setActiveId(undefined),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: (navigation_module_default()).navToplevelList,
                children: navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((param)=>/*#__PURE__*/ {
                    let [{ id , text , link  }] = param;
                    return (0,jsx_runtime.jsx)("li", {
                        className: classnames_default()((navigation_module_default()).navToplevelItem, {
                            [(navigation_module_default()).navToplevelItemActive]: activeId === id
                        }),
                        onMouseEnter: ()=>setActiveId(id),
                        onKeyDown: (e)=>handleKeyDown(e, id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            tabIndex: 0,
                            role: "button",
                            href: link,
                            className: (navigation_module_default()).navToplevelItemLink,
                            children: text
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavigationItems, {
                navigationItems: navigationItems,
                activeId: activeId
            })
        ]
    });
};
/* harmony default export */ var navigation_TopLevelNavigation = (TopLevelNavigation);

;// CONCATENATED MODULE: ./modules/pages/navigation/navigation.tsx











const Navigation = (param)=>{
    let { navigationItems , footerItems , builderNavLinks  } = param;
    var ref;
    const [isMobileMenuActive, setIsMobileMenuActive] = (0,react.useState)(false);
    const [needCloseMobileMenu, setNeedCloseMobileMenu] = (0,react.useState)(false);
    const { locale  } = (0,LangHelper/* useLocale */.bU)();
    const { width =0  } = (0,useWindowSize/* useWindowSize */.i)();
    (0,react.useEffect)(()=>{
        if (width < 1024) {
            if (needCloseMobileMenu) {
                setNeedCloseMobileMenu(false);
                setIsMobileMenuActive(false);
            }
        } else {
            setNeedCloseMobileMenu(true);
            if (isMobileMenuActive) {
                setIsMobileMenuActive(false);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        width
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (navigation_module_default()).globalHeader,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (navigation_module_default()).navBorder,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (navigation_module_default()).navContainer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (navigation_module_default()).mobileNavigationContainer,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((navigation_module_default()).hamburgerLines, {
                                    [(navigation_module_default()).active]: isMobileMenuActive
                                }),
                                onClick: ()=>setIsMobileMenuActive((val)=>!val),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((navigation_module_default()).line, (navigation_module_default()).line1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((navigation_module_default()).line, (navigation_module_default()).line2)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()((navigation_module_default()).line, (navigation_module_default()).line3)
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (navigation_module_default()).navLogoContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (navigation_module_default()).navLogo,
                                    href: (ref = LangHelper/* LOCALE_LINKS */.kV[locale]) === null || ref === void 0 ? void 0 : ref.home,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        type: Icon/* IconType.Afterpay */.T.Afterpay
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (navigation_module_default()).navLinksContainer,
                                    children: builderNavLinks ? builderNavLinks.map((param, index)=>{
                                        let { data  } = param;
                                        var ref, ref1;
                                        if ((data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.url) && (data === null || data === void 0 ? void 0 : (ref1 = data.link) === null || ref1 === void 0 ? void 0 : ref1.text)) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (navigation_module_default()).navToplevelItemLink,
                                                role: "button",
                                                target: !data.link.newTab ? undefined : "_blank",
                                                href: data.link.url,
                                                rel: "noopener noreferrer",
                                                children: data.link.text
                                            }, index);
                                        }
                                    }) : null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_SearchBar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_Auth, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_TopLevelNavigation, {
                    navigationItems: navigationItems
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_MobileNavigation, {
                    navigationItems: navigationItems,
                    footerItems: footerItems,
                    isMobileMenuActive: isMobileMenuActive
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/default-layout/index.tsx



const DefaultLayout = (props)=>{
    const { headerItems , headerBuilderItems , footerItems , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation, {
                navigationItems: headerItems,
                builderNavLinks: headerBuilderItems,
                footerItems: footerItems
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {
                footerData: footerItems
            })
        ]
    });
};
/* harmony default export */ var default_layout = (DefaultLayout);


/***/ }),

/***/ 204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ LazyBackgroundImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7650);
/* harmony import */ var _helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1198);




const LazyBackgroundImage = (props)=>{
    const { className ="" , imageUrl , imageWidth , ...rest } = props;
    const { ref , inView  } = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* .useInView */ .YD)();
    const [wasSeen, setWasSeen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [currentImage, setCurrentImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getPlaceholderBuilderImage */ .W)(imageUrl));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (inView && !wasSeen) {
            setWasSeen(true);
        }
    }, [
        inView,
        wasSeen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let cancelled = false;
        const resizeParams = {};
        if (imageWidth && imageWidth > 1) {
            resizeParams.width = imageWidth;
        }
        if (wasSeen) {
            const resizedImage = (0,_helpers_BuilderHelper__WEBPACK_IMPORTED_MODULE_2__/* .getResizedBuilderImage */ .bs)(imageUrl, resizeParams);
            const loadingImage = new Image();
            loadingImage.onload = ()=>{
                if (!cancelled) {
                    setCurrentImage(resizedImage);
                }
            };
            loadingImage.src = resizedImage !== null && resizedImage !== void 0 ? resizedImage : "";
        }
        return ()=>{
            cancelled = true;
        };
    }, [
        wasSeen,
        imageUrl,
        imageWidth
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: ref,
        className: className,
        ...rest,
        style: {
            ...rest === null || rest === void 0 ? void 0 : rest.style,
            backgroundImage: "url('".concat(currentImage, "')")
        }
    });
};


/***/ }),

/***/ 2135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MetaBlock; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2132);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2991);
/* harmony import */ var _config_next_csp_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5331);
/* harmony import */ var _config_next_csp_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_config_next_csp_config__WEBPACK_IMPORTED_MODULE_3__);




function MetaBlock(props) {
    const { title , description , leadImage , canonicalUrl  } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "Content-Security-Policy",
                content: (_config_next_csp_config__WEBPACK_IMPORTED_MODULE_3___default())
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            !!canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "twitter:description",
                content: description
            }),
            leadImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: leadImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "twitter:image",
                        content: leadImage
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _image_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87);
/* harmony import */ var _image_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_image_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const ImageSkeleton = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_image_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2___default().imageSkeleton)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageSkeleton);


/***/ }),

/***/ 8192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7751);
/* harmony import */ var _text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const TextSkeleton = (props)=>{
    const [widthText, heightText] = props.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_text_skeleton_module_scss__WEBPACK_IMPORTED_MODULE_2___default().textSkeleton),
        style: {
            height: heightText,
            width: widthText
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextSkeleton);


/***/ }),

/***/ 5331:
/***/ (function(module) {

"use strict";
// Used for Staging and Production

const CSP_SETTINGS = {
    "script-src": [
        "'self'",
        "'unsafe-eval'",
        "'unsafe-inline'",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "*.clearpay.com",
        "*.googleapis.com",
        "public.fbot.me",
        "static.fbot.me",
        "campaign.fbot.me",
        "lcx-embed.bambuser.com",
        "www.googletagmanager.com",
        "*.onetrust.com",
        "cdn.branch.io",
        "sc-static.net",
        "snap.licdn.com",
        "connect.facebook.net",
        "munchkin.marketo.net",
        "www.googleadservices.com",
        "cdn.dashhudson.com",
        "cdn.builder.io",
        "t.contentsquare.net",
        "www.google-analytics.com",
        "googleads.g.doubleclick.net",
        "app.link",
        "v5tufwer.micpn.com",
        "pi.pardot.com",
        "tag.rmp.rakuten.com",
        "metadata-static-files.sfo2.cdn.digitaloceanspaces.com/pixel/lp.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/tracking.min.js",
        "x.clearbitjs.com/v2/pk_ba428737ee82fd942f13030da0c2629b/destinations.min.js",
        "analytics.tiktok.com/i18n/pixel/events.js",
        "analytics.tiktok.com/i18n/pixel/config.js",
        "analytics.tiktok.com/i18n/pixel/identify.js",
        "bat.bing.com",
        "afterpay-consumer-content-hub.vercel.app",
        "*.ads-twitter.com",
        "js.adsrvr.org",
        "cdn.bizible.com",
        "analytics.twitter.com",
        "t.co",
        "bat.bing.com",
        "widget.trustpilot.com",
        "*.instagram.com",
        "*.twitter.com",
        "cdn.amplitude.com"
    ],
    "img-src": [
        "'self'",
        "data:",
        "*.afterpay.com",
        "*.clearpay.co.uk",
        "maps.gstatic.com",
        "*.googleapis.com",
        "*.ggpht",
        "cdn.builder.io",
        "static.fbot.me",
        "www.google.co.nz",
        "www.google.co.uk",
        "www.google.com",
        "www.google.com.au",
        "www.googletagmanager.com",
        "px.ads.linkedin.com",
        "www.facebook.com",
        "p.adsymptotic.com",
        "cdn.branch.io",
        "www.google-analytics.com",
        "public.fbot.me",
        "connect.facebook.net",
        "*.onetrust.com",
        "cdn.dashhudson.com",
        "likeshop.me",
        "track.linksynergy.com",
        "consent.linksynergy.com",
        "www.kmart.com.au",
        "www.bigw.com.au/",
        "www.pacsun.com",
        "afterpay-consumer-content-hub.vercel.app",
        "cdn.bizible.com",
        "*.google.ie",
        "bat.bing.com",
        "t.co",
        "cdn.bizibly.com",
        "m7q46igbwl.execute-api.ap-southeast-2.amazonaws.com",
        "images.asos-media.com"
    ],
    "object-src": [
        "'none'"
    ],
    "base-uri": [
        "'none'"
    ]
};
const CSP = Object.entries(CSP_SETTINGS).reduce((previousValue, param)=>{
    let [key, cspValues] = param;
    const cspString = cspValues.join(" ");
    return "".concat(previousValue, " ").concat(key, " ").concat(cspString, ";");
}, "").trim();
module.exports = CSP;


/***/ }),

/***/ 1198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "As": function() { return /* binding */ BUILDER_MODEL; },
/* harmony export */   "CN": function() { return /* binding */ getPageFromPageID; },
/* harmony export */   "Jq": function() { return /* binding */ mapBuilderObjectToArticle; },
/* harmony export */   "NE": function() { return /* binding */ getArticleFromID; },
/* harmony export */   "W": function() { return /* binding */ getPlaceholderBuilderImage; },
/* harmony export */   "Zd": function() { return /* binding */ getArticlesByCategory; },
/* harmony export */   "bs": function() { return /* binding */ getResizedBuilderImage; },
/* harmony export */   "eA": function() { return /* binding */ getRelatedArticles; },
/* harmony export */   "gg": function() { return /* binding */ getLatestArticles; },
/* harmony export */   "jG": function() { return /* binding */ getArticleFromIDs; },
/* harmony export */   "lB": function() { return /* binding */ getBuilderPage; },
/* harmony export */   "nq": function() { return /* binding */ getCategoriesFromIDs; },
/* harmony export */   "tG": function() { return /* binding */ getAllCategories; },
/* harmony export */   "td": function() { return /* binding */ getArticlesFromBuilderReference; },
/* harmony export */   "zC": function() { return /* binding */ getAllArticles; }
/* harmony export */ });
/* unused harmony exports mapBuilderObjectToCategory, mapBuilderObjectToProduct, mapBuilderObjectToBrand, getArticlePageFromUrl, getCategoryFromName, getCategoryFromID, getArticleSearchResults, getBrandFromIDs, getProductFromIDs, getAllArticlePaths */
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5102);
/* harmony import */ var _builder_io_sdk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1183);
/* harmony import */ var _shared_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9771);
/* harmony import */ var _LangHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7868);




_builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].init */ .ZP.init(_shared_env__WEBPACK_IMPORTED_MODULE_2__/* .BUILDER_API_KEY */ .uT);
const CATEGORY_ROOT = "/the-loop/";
function mapBuilderObjectToArticle(object) {
    var ref, ref1, ref2, ref3;
    if (!object) {
        return;
    }
    const oData = object.data;
    const categories = (ref = oData.categories) === null || ref === void 0 ? void 0 : ref.map((category)=>mapBuilderObjectToCategory(category.category.value));
    const author = oData === null || oData === void 0 ? void 0 : (ref1 = oData.author) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.data;
    var ref4;
    const articleSlug = (ref4 = (ref3 = oData.url) === null || ref3 === void 0 ? void 0 : ref3.replace("/builder/", "")) !== null && ref4 !== void 0 ? ref4 : "";
    const articleUrl = categories && categories.length ? "".concat(categories[0].categoryUrl, "/").concat(articleSlug).replace(/\/{2,}/, "/") : null;
    var _title, _description, _leadImage, _leadPortraitImage, _leadImagePosition, _priority, _seoTitle, ref5, _seoDescription, ref6, _lastUpdated, _overrideDate, _createdDate;
    return {
        id: object.id,
        title: (_title = oData.title) !== null && _title !== void 0 ? _title : "",
        description: (_description = oData.description) !== null && _description !== void 0 ? _description : "",
        categories: categories !== null && categories !== void 0 ? categories : null,
        author: author !== null && author !== void 0 ? author : null,
        leadImage: (_leadImage = oData.leadImage) !== null && _leadImage !== void 0 ? _leadImage : null,
        leadPortraitImage: (_leadPortraitImage = oData.leadPortraitImage) !== null && _leadPortraitImage !== void 0 ? _leadPortraitImage : null,
        leadImagePosition: (_leadImagePosition = oData.leadImagePosition) !== null && _leadImagePosition !== void 0 ? _leadImagePosition : "center",
        url: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleUrl: articleUrl !== null && articleUrl !== void 0 ? articleUrl : "",
        articleSlug,
        priority: (_priority = oData.priority) !== null && _priority !== void 0 ? _priority : 0,
        builderModel: object !== null && object !== void 0 ? object : null,
        seoTitle: (ref5 = (_seoTitle = oData.seoTitle) !== null && _seoTitle !== void 0 ? _seoTitle : oData.title) !== null && ref5 !== void 0 ? ref5 : "",
        seoDescription: (ref6 = (_seoDescription = oData.seoDescription) !== null && _seoDescription !== void 0 ? _seoDescription : oData.description) !== null && ref6 !== void 0 ? ref6 : "",
        lastUpdated: (_lastUpdated = object.lastUpdated) !== null && _lastUpdated !== void 0 ? _lastUpdated : null,
        overrideDate: (_overrideDate = oData.overrideDate) !== null && _overrideDate !== void 0 ? _overrideDate : null,
        createdDate: (_createdDate = object.createdDate) !== null && _createdDate !== void 0 ? _createdDate : null,
        readingTime: oData.readingTime
    };
}
function mapBuilderObjectToCategory(item) {
    if (!item) {
        return {
            id: "",
            name: "",
            longName: null,
            description: "",
            categoryUrl: "",
            image: "",
            lastUpdated: "",
            seoTitle: "",
            seoDescription: ""
        };
    }
    let name;
    let category = item;
    if (item.data === undefined) {
        var _name;
        name = (_name = item.name) !== null && _name !== void 0 ? _name : "";
    } else {
        category = item.data;
        var _name1;
        name = (_name1 = item.name) !== null && _name1 !== void 0 ? _name1 : item.data.name;
    }
    const categorySlug = categoryNameToUrlSlug(name);
    var _longName;
    // TODO generalize this parser here
    return {
        id: item.id,
        name,
        longName: (_longName = category.longName) !== null && _longName !== void 0 ? _longName : null,
        categoryUrl: (CATEGORY_ROOT + categorySlug).replace(/\/{2,}/g, "/"),
        categorySlug,
        description: category.description || "",
        image: category.image || "",
        lastUpdated: item.lastUpdated || "",
        seoTitle: item.seoTitle || "",
        seoDescription: item.seoDescription || "",
        landscapeImage: item.landscapeImage || ""
    };
}
function mapBuilderObjectToProduct(item) {
    if (!item) {
        return {
            id: "",
            name: "",
            description: "",
            leadImage: "",
            price: 0,
            priceUnit: "$"
        };
    }
    const oData = item.data;
    return {
        id: item.id,
        name: oData.name,
        description: oData.description,
        leadImage: oData.leadImage,
        brand: mapBuilderObjectToBrand(oData.brand),
        price: oData.price || 0,
        priceUnit: oData.priceUnit || "$",
        url: oData.url,
        lastUpdated: item.lastUpdated,
        installment: oData.installment
    };
}
function mapBuilderObjectToBrand(item) {
    if (!item) {
        return {
            id: "",
            name: "",
            logo: "",
            lastUpdated: ""
        };
    }
    let oData = item.data;
    if (item["@type"] && item.value) {
        oData = item.value.data;
    }
    return {
        id: item.id,
        name: oData === null || oData === void 0 ? void 0 : oData.name,
        logo: oData === null || oData === void 0 ? void 0 : oData.logo,
        lastUpdated: item.lastUpdated
    };
}
const categoryNameToUrlSlug = (name)=>{
    return name.trim().toLowerCase().replace(/[^A-z]/g, "-").trimEnd();
};
const getAllArticles = async function(locale, filters, sort) {
    let includeUnpublished = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, limitFields = arguments.length > 4 ? arguments[4] : void 0;
    var ref;
    const getConfig = {
        query: {},
        options: {
            noTargeting: true,
            includeUnpublished
        }
    };
    if (filters === null || filters === void 0 ? void 0 : filters.extra) {
        getConfig.query = filters === null || filters === void 0 ? void 0 : filters.extra;
    }
    if (locale) {
        getConfig.query.query = {
            $elemMatch: {
                property: {
                    $eq: "locale"
                },
                value: locale
            }
        };
    }
    if (filters === null || filters === void 0 ? void 0 : (ref = filters.categoryIds) === null || ref === void 0 ? void 0 : ref.length) {
        getConfig.query["data.categories"] = {
            $elemMatch: {
                "category.id": {
                    $in: filters.categoryIds
                }
            }
        };
    }
    if (sort && getConfig.options) {
        getConfig.options.sort = sort;
    }
    if (limitFields) {
        getConfig.fields = limitFields;
    }
    getConfig.limit = filters === null || filters === void 0 ? void 0 : filters.limit;
    if (getConfig.options) {
        if (typeof (filters === null || filters === void 0 ? void 0 : filters.offset) === "string") {
            var ref1;
            getConfig.options.offset = parseInt((ref1 = filters === null || filters === void 0 ? void 0 : filters.offset) !== null && ref1 !== void 0 ? ref1 : "0");
        } else {
            getConfig.options.offset = filters === null || filters === void 0 ? void 0 : filters.offset;
        }
    }
    const articles = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("article", getConfig);
    return articles.map((page)=>{
        return mapBuilderObjectToArticle(page);
    }).filter((page)=>page !== undefined);
};
const getArticlePage = async function(params) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getBuilderPage("article", params, includeUnpublished);
};
const getBuilderPage = async function(model, params) {
    let includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const query = {
        userAttributes: {},
        options: {
            includeUnpublished,
            noTargeting: false
        }
    };
    if (params.url) {
        query.userAttributes.urlPath = params.url;
        if (params.locale) {
            query.userAttributes.locale = params.locale;
        } else {
            query.userAttributes.locale = _LangHelper__WEBPACK_IMPORTED_MODULE_3__/* .ALL_LOCALES */ .En;
        }
    }
    if (params.modelId) {
        query.entry = params.modelId;
    }
    // TODO replace these string entries with constants
    const article = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get(model, query).toPromise() || null;
    return article;
};
const getArticlePageFromUrl = async function() {
    let path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", locale = arguments.length > 1 ? arguments[1] : void 0, includeUnpublished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return getArticlePage({
        url: "/builder/" + path,
        locale
    }, includeUnpublished);
};
const getArticleFromID = async function(modelId) {
    let includeUnpublished = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return getArticlePage({
        modelId
    }, includeUnpublished);
};
const getCategoryFromName = async (name)=>{
    const slug = categoryNameToUrlSlug(name);
    const allPossibleCategories = await getAllCategories();
    for (const category of allPossibleCategories){
        if ("".concat(CATEGORY_ROOT).concat(slug) === category.categoryUrl) {
            // TODO refactor check to come from a generic place
            return category;
        }
    }
    return null;
};
const getCategoryFromID = async (modelId)=>{
    const foundCategory = await getBuilderPage("category", {
        modelId
    }, true);
    if (foundCategory) {
        return mapBuilderObjectToCategory(foundCategory);
    }
    return null;
};
const getArticlesByCategory = async (param)=>{
    let { locale , offset , limit =9 , categoryIds =[]  } = param;
    return await getAllArticles(locale, {
        categoryIds,
        limit,
        offset
    }, {
        "data.overrideDate": -1,
        createdDate: -1
    });
};
const getLatestArticles = async (param)=>{
    let { locale , offset , limit =4 , categoryIds =[] , excludeIds =[]  } = param;
    let extra = {};
    if (excludeIds === null || excludeIds === void 0 ? void 0 : excludeIds.length) {
        extra = {
            id: {
                $not: {
                    $in: excludeIds
                }
            }
        };
    }
    return getAllArticles(locale, {
        extra,
        categoryIds,
        offset,
        limit
    }, {
        "data.overrideDate": -1,
        createdDate: -1
    });
};
let cachedCategoryList = [];
const getAllCategories = async ()=>{
    // TODO add caching mechanism to avoid loading this over and over again
    if (cachedCategoryList.length !== 0) {
        return cachedCategoryList;
    }
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        }
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    if (cachedCategoryList.length === 0) {
        cachedCategoryList = categoriesData;
    }
    return categoriesData;
};
const getCategoriesFromIDs = async function() {
    let categoryIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("category", {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: categoryIds
            }
        }
    });
    const categoriesData = allCategory.map((item)=>mapBuilderObjectToCategory(item));
    return categoriesData;
};
const getPageFromPageID = async (id)=>{
    return getBuilderPage("page", {
        modelId: id
    }, true);
};
const getArticleSearchResults = async function(locale, keyword) {
    let limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 25, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, onlyFields = arguments.length > 4 ? arguments[4] : void 0;
    return getAllArticles(locale, {
        extra: {
            $or: [
                {
                    name: {
                        $regex: keyword,
                        $options: "i"
                    }
                },
                {
                    description: {
                        $regex: keyword,
                        $options: "i"
                    }
                },
                {
                    "data.title": {
                        $regex: keyword,
                        $options: "i"
                    }
                }
            ]
        },
        limit,
        offset
    }, undefined, false, onlyFields);
};
const getArticleFromIDs = async function() {
    let articleIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll(BUILDER_MODEL.ARTICLE, {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: articleIds
            }
        }
    });
    const articleData = allCategory.map((item)=>mapBuilderObjectToArticle(item)).filter((page)=>page !== undefined);
    return articleData;
};
const getBrandFromIDs = async function() {
    let brandIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await builder.getAll(BUILDER_MODEL.BRAND, {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: brandIds
            }
        }
    });
    const brandsData = allCategory.map((item)=>mapBuilderObjectToBrand(item));
    return brandsData;
};
const getProductFromIDs = async function() {
    let productIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    const allCategory = await builder.getAll(BUILDER_MODEL.PRODUCT, {
        options: {
            noTargeting: true,
            includeUnpublished: false
        },
        query: {
            id: {
                $in: productIds
            }
        }
    });
    const productsData = allCategory.map((item)=>mapBuilderObjectToProduct(item));
    return productsData;
};
/**
 * Function used for fetching paths for Static Path mapping
 *
 * @returns Promise
 */ const getAllArticlePaths = async ()=>{
    const pathArray = [];
    let currentOffset = 0;
    const fetchArticles = async (offset)=>{
        const currentArticles = await getAllArticles(undefined, {
            offset,
            limit: 10
        });
        currentArticles.map((page)=>{
            var ref;
            const queryFilters = page.builderModel.query;
            // Check if page has lang
            if (queryFilters.length > 0 && ((ref = queryFilters[1]) === null || ref === void 0 ? void 0 : ref.property) == "locale") {
                queryFilters[1].value.forEach((lang)=>{
                    var ref;
                    (ref = page.categories) === null || ref === void 0 ? void 0 : ref.forEach((category)=>{
                        if (category.categoryUrl) {
                            var ref;
                            const contentHubPath = (ref = LOCALE_LINKS[lang]) === null || ref === void 0 ? void 0 : ref.contentHubRoot;
                            var _categorySlug;
                            pathArray.push({
                                lang,
                                category: (_categorySlug = category.categorySlug) !== null && _categorySlug !== void 0 ? _categorySlug : "",
                                article: page.articleSlug,
                                business: contentHubPath !== null && contentHubPath !== void 0 ? contentHubPath : ContentHubUrlPrefix.TheLoop
                            });
                        }
                    });
                });
            }
        });
        if (currentArticles.length === 10) {
            await fetchArticles(currentOffset += 10);
        }
    };
    await fetchArticles(currentOffset);
    return pathArray;
};
const getArticlesFromBuilderReference = async (articles)=>{
    if (_builder_io_sdk__WEBPACK_IMPORTED_MODULE_1__/* .Builder.isEditing */ .Ib.isEditing) {
        const articleIds = (articles || []).map((article)=>{
            var ref;
            return article === null || article === void 0 ? void 0 : (ref = article.article) === null || ref === void 0 ? void 0 : ref.id;
        }).filter(Boolean);
        return getArticleFromIDs(articleIds);
    }
    const categoryMap = {};
    const categoryIds = [];
    (articles || []).forEach((article)=>{
        var ref, ref1, ref2;
        article === null || article === void 0 ? void 0 : (ref = article.article) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.categories.forEach((categoryRef)=>{
            const category = categoryRef.category;
            if (category.value && category.value.id) {
                categoryMap[category.value.id] = category.value;
            } else {
                categoryIds.push(category.id);
            }
        });
    });
    const categories = await getCategoriesFromIDs(categoryIds);
    categories.forEach((category)=>{
        categoryMap[category.id] = category;
    });
    const updatedArticles = (articles || []).map((article)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const categories = article === null || article === void 0 ? void 0 : (ref = article.article) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.categories.map((categoryRef)=>{
            const category = categoryRef.category;
            return {
                category: {
                    value: categoryMap[category.id]
                }
            };
        });
        return mapBuilderObjectToArticle({
            ...(article === null || article === void 0 ? void 0 : (ref3 = article.article) === null || ref3 === void 0 ? void 0 : ref3.value) || {},
            data: {
                ...(article === null || article === void 0 ? void 0 : (ref4 = article.article) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.data) || {},
                categories
            }
        });
    }).filter((page)=>page !== undefined);
    return updatedArticles;
};
const getRelatedArticles = async (article, locale)=>{
    if (!article) {
        return [];
    }
    const categoryIds = article.categories ? [
        ...article.categories
    ].map((item)=>{
        return item.id;
    }) : [];
    const relatedPages = await _builder_io_react__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getAll */ .ZP.getAll("article", {
        options: {
            noTargeting: true
        },
        query: {
            id: {
                $ne: article.builderModel.id
            },
            "data.categories": {
                $elemMatch: {
                    "category.id": {
                        $in: [
                            categoryIds[0]
                        ]
                    }
                }
            },
            query: {
                $elemMatch: {
                    property: {
                        $eq: "locale"
                    },
                    value: locale
                }
            }
        },
        limit: 3
    });
    const relatedArticles = relatedPages.map((page)=>{
        return mapBuilderObjectToArticle(page);
    }).filter((page)=>page !== undefined);
    return relatedArticles;
};
var BUILDER_MODEL;
(function(BUILDER_MODEL) {
    BUILDER_MODEL["ARTICLE"] = "article";
    BUILDER_MODEL["ARTICLE_AUTHOR"] = "article-author";
    BUILDER_MODEL["PAGE"] = "page";
    BUILDER_MODEL["CATEGORY"] = "category";
    BUILDER_MODEL["BRAND"] = "brand";
    BUILDER_MODEL["PRODUCT"] = "product";
})(BUILDER_MODEL || (BUILDER_MODEL = {}));
const getResizedBuilderImage = (source, parameters)=>{
    if (source && source.startsWith("https://cdn.builder.io/api/v1/image/")) {
        const queryArray = [];
        if (parameters) {
            var _quality;
            parameters.quality = (_quality = parameters.quality) !== null && _quality !== void 0 ? _quality : 85;
            parameters.format = "webp";
            const parameterKeys = Object.keys(parameters);
            parameterKeys.forEach((paramKey)=>{
                const paramValue = parameters[paramKey];
                if (paramValue) {
                    queryArray.push("".concat(paramKey, "=").concat(paramValue));
                }
            });
        }
        return "".concat(source, "?").concat(queryArray.join("&"));
    }
    return source;
};
const getPlaceholderBuilderImage = (source)=>{
    return getResizedBuilderImage(source, {
        width: 1,
        height: 1
    });
};


/***/ }),

/***/ 8362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ CORE_SITE_DOMAIN; },
/* harmony export */   "Gm": function() { return /* binding */ DEFAULT_REQUEST_TIMEOUT; },
/* harmony export */   "HZ": function() { return /* binding */ NAVIGATION_ITEM_COLORS; },
/* harmony export */   "JN": function() { return /* binding */ CORRELATION_ID_HEADER_KEY; },
/* harmony export */   "_V": function() { return /* binding */ REQUEST_ID_STORE_KEY; }
/* harmony export */ });
const NAVIGATION_ITEM_COLORS = {
    BLACK: "black",
    FIRE: "fire",
    ORCA: "orca"
};
const REQUEST_ID_STORE_KEY = "req-id";
const DEFAULT_REQUEST_TIMEOUT = 10000;
const CORRELATION_ID_HEADER_KEY = "correlation-id";
const CORE_SITE_DOMAIN = "https://www.afterpay.com";


/***/ }),

/***/ 2316:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"twoLinesLimit":"article-card_twoLinesLimit__sZzEk","articleCard":"article-card_articleCard__HFkhe","small":"article-card_small__QuBQy","articleCardContentDescription":"article-card_articleCardContentDescription__WBryE","articleCardContentTitle":"article-card_articleCardContentTitle__N7OBs","dot":"article-card_dot__9r6EZ","expand":"article-card_expand__D1L5l","fixedWidth":"article-card_fixedWidth__vXjkU","articleCardImage":"article-card_articleCardImage__fg3ta","articleCardImageWrapper":"article-card_articleCardImageWrapper__icPpM","loading":"article-card_loading__5rwx9","articleCardContentWrapper":"article-card_articleCardContentWrapper__8r6BV","categoriesList":"article-card_categoriesList__PRHah","articleCardContent":"article-card_articleCardContent___c9mF","articleCardButtonReadMore":"article-card_articleCardButtonReadMore__CCSn9","large":"article-card_large__tyR2F","articleCardLink":"article-card_articleCardLink__AKN6Y","video-spin":"article-card_video-spin__dgTcO"};

/***/ }),

/***/ 4688:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"article-grid_articleGrid__h5gxn","articlesContainer":"article-grid_articlesContainer__0_Gqg","articleLarge":"article-grid_articleLarge__wKq6N","buttonLoadMore":"article-grid_buttonLoadMore__tOrmA","buttonLoadMoreContent":"article-grid_buttonLoadMoreContent__Clnq0","loading":"article-grid_loading__vRiUm","loaded":"article-grid_loaded___t6kZ","spinnerLoadMore":"article-grid_spinnerLoadMore__tY_1b","video-spin":"article-grid_video-spin__PD195","loadMoreContainer":"article-grid_loadMoreContainer__V0lck"};

/***/ }),

/***/ 8099:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"dropdown-selector_dropdownSelector__8Ng7S","video-spin":"dropdown-selector_video-spin__3eEsl"};

/***/ }),

/***/ 4494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleCardSkeleton":"article-card-skeleton_articleCardSkeleton__NjLPl","articleCardSkeletonImage":"article-card-skeleton_articleCardSkeletonImage__4BY1w","articleCardSkeletonLeftContent":"article-card-skeleton_articleCardSkeletonLeftContent__ohasg","articleCardSkeletonLeftContentTitle":"article-card-skeleton_articleCardSkeletonLeftContentTitle__V1ORu","articleCardSkeletonLeftContentDescription":"article-card-skeleton_articleCardSkeletonLeftContentDescription__iRuGz","small":"article-card-skeleton_small__9BU_u","video-spin":"article-card-skeleton_video-spin__4eU57"};

/***/ }),

/***/ 3551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articleGridSkeleton":"article-grid-skeleton_articleGridSkeleton__2q0XE","video-spin":"article-grid-skeleton_video-spin__Cbmzd"};

/***/ }),

/***/ 87:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageSkeleton":"image-skeleton_imageSkeleton__qVtcU","shimmer":"image-skeleton_shimmer__iv_Tj","video-spin":"image-skeleton_video-spin__UZLsz","fadeIn":"image-skeleton_fadeIn__eOp5w"};

/***/ }),

/***/ 7751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"textSkeleton":"text-skeleton_textSkeleton__4DoZV","shimmer":"text-skeleton_shimmer__sZS7G","video-spin":"text-skeleton_video-spin__HP3Ds","fadeIn":"text-skeleton_fadeIn__YNUIA"};

/***/ }),

/***/ 5867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__LMMWQ","footerDivider":"footer_footerDivider__6_ZxD","footerInner":"footer_footerInner__rh0_Q","footerTitle":"footer_footerTitle__2b_JY","footerBlock":"footer_footerBlock__J1vxw","legalText":"footer_legalText__a5dmD","footerTop":"footer_footerTop__MZlz3","footerBottom":"footer_footerBottom__eqXes","footerLocation":"footer_footerLocation__st5rO","logoAfterPay":"footer_logoAfterPay__a_KBS","video-spin":"footer_video-spin__nMiAH"};

/***/ }),

/***/ 6358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"authcontainer":"Auth_authcontainer__kh72H","ctaContainer":"Auth_ctaContainer__lcEkn","buttonContainer":"Auth_buttonContainer__HvABp","buttonsIcon":"Auth_buttonsIcon__Wm4xf","buttonsNavigation":"Auth_buttonsNavigation__I_X8G","loginButtonLabel":"Auth_loginButtonLabel__KHJls","video-spin":"Auth_video-spin__CO33V"};

/***/ }),

/***/ 3406:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mobileNavigationContainer":"mobileNavigation_mobileNavigationContainer__JQM53","mobileNavigationContainerActive":"mobileNavigation_mobileNavigationContainerActive__FUuAA","mobileNavigationContent":"mobileNavigation_mobileNavigationContent__SdCTQ","mobileNavigationItem":"mobileNavigation_mobileNavigationItem__29gZ3","mobileNavigationSubMenuItem":"mobileNavigation_mobileNavigationSubMenuItem__im2Ng","mobileNavigationSubMenuItemBold":"mobileNavigation_mobileNavigationSubMenuItemBold__QMkmL","mobileNavigationSubMenuItemBlack":"mobileNavigation_mobileNavigationSubMenuItemBlack__wEJPV","mobileNavigationSubMenuItemOrca":"mobileNavigation_mobileNavigationSubMenuItemOrca__rdnR7","mobileNavigationSubMenuItemFire":"mobileNavigation_mobileNavigationSubMenuItemFire__qb9ce","mobileNavigationChevronContainer":"mobileNavigation_mobileNavigationChevronContainer___jgIz","mobileNavigationChevron":"mobileNavigation_mobileNavigationChevron__vL_MF","mobileNavigationChevronActive":"mobileNavigation_mobileNavigationChevronActive__5R7oK","mobileNavigationSubMenuContainer":"mobileNavigation_mobileNavigationSubMenuContainer__nymUT","mobileNavigationDivider":"mobileNavigation_mobileNavigationDivider__vCR5F","mobileNavigationFooterContainer":"mobileNavigation_mobileNavigationFooterContainer__fdzZR","footerNavigationItemsContainer":"mobileNavigation_footerNavigationItemsContainer__G6pdj","footerNavigationItem":"mobileNavigation_footerNavigationItem__5RejK","footerInformationContainer":"mobileNavigation_footerInformationContainer__j02Iq","footerLogo":"mobileNavigation_footerLogo__yvOkb","footerServiceContent":"mobileNavigation_footerServiceContent__f_dK7","video-spin":"mobileNavigation_video-spin__2ezsW"};

/***/ }),

/***/ 8163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resultNotFound":"search-bar_resultNotFound__R7r3f","searchInputWrapper":"search-bar_searchInputWrapper__zdoFg","searchInput":"search-bar_searchInput__ocugf","searchBarWrapper":"search-bar_searchBarWrapper__ZmwnI","searchBarForm":"search-bar_searchBarForm__EtDtp","storeNameHighlighted":"search-bar_storeNameHighlighted__3C_Zl","searchBarSuggestionWrapper":"search-bar_searchBarSuggestionWrapper__rT3Dm","loadingSpinnerContainer":"search-bar_loadingSpinnerContainer__lNHnR","searchBarSuggestionHeading":"search-bar_searchBarSuggestionHeading__4YdUQ","optionListDivider":"search-bar_optionListDivider__9eUdg","searchBarSuggestionOption":"search-bar_searchBarSuggestionOption__M5Ifv","searchBarSuggestionOptionActive":"search-bar_searchBarSuggestionOptionActive__Shicq","searchBarSuggestionSeeMoreLink":"search-bar_searchBarSuggestionSeeMoreLink__0pqeZ","showSuggestionList":"search-bar_showSuggestionList__dTQbG","video-spin":"search-bar_video-spin__w2w9Z"};

/***/ }),

/***/ 2125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"navigation_globalHeader__9n4RV","navBorder":"navigation_navBorder__L0Qx2","navContainer":"navigation_navContainer__qVXH3","navLogoContainer":"navigation_navLogoContainer__0LSAW","navLogo":"navigation_navLogo__3XC5X","mobileNavigationContainer":"navigation_mobileNavigationContainer__e1iXS","hamburgerLines":"navigation_hamburgerLines__bUSNH","line":"navigation_line__W9hcW","line1":"navigation_line1__YOPlX","line2":"navigation_line2__gSvyE","line3":"navigation_line3__seNPe","active":"navigation_active__MWQR3","navLinksContainer":"navigation_navLinksContainer__BKNhe","navToplevelList":"navigation_navToplevelList__JhoDN","navToplevelItem":"navigation_navToplevelItem__nCY2K","navToplevelItemActive":"navigation_navToplevelItemActive__y2p63","navToplevelItemLink":"navigation_navToplevelItemLink__3mBET","subNavigationContainer":"navigation_subNavigationContainer__IhcHt","subNavigation":"navigation_subNavigation__O3Quf","subNavigationItem":"navigation_subNavigationItem__aQJPM","subNavigationItemBold":"navigation_subNavigationItemBold__lgg59","subNavigationItemBlack":"navigation_subNavigationItemBlack___GBJf","subNavigationItemOrca":"navigation_subNavigationItemOrca__eb0Kv","subNavigationItemFire":"navigation_subNavigationItemFire__zZSWh","subNavigationItemHover":"navigation_subNavigationItemHover__cRNLM","navToplevel":"navigation_navToplevel__ttqSK","video-spin":"navigation_video-spin__tX1BO"};

/***/ }),

/***/ 4256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page-layout":"generic_page-layout__xvmcs","video-spin":"generic_video-spin__CR2l7"};

/***/ }),

/***/ 3427:
/***/ (function() {

/* (ignored) */

/***/ })

}]);